import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import { ImageType } from '@/common/components/imageGallery/components/Extensions/moreItemsExtension/moreItemsExtension.type';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import MainLayout from '@/common/components/layouts/MainLayout';
import { ImagesListName } from '@/common/utils/ImagesListName';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';

const OtherDamagedPreviewImages = ({
  images,
  updateImages,
  editImage,
}: {
  images: Array<ImageType & { id: string }>;
  updateImages: ({ imageId }: { imageId: string }) => void;
  editImage: ({ image }: { image: ImageType & { id: string } }) => void;
}) => {
  return (
    <MainLayout header="titleHeader" title="پیش نمایش تصویر" hasBottomPadding>
      <Box pt={'1.5rem'}>
        <TitleDescription>تصاویر زیان‌دیده</TitleDescription>
        <Typography color="black-1" my="1.5rem">
          کارشناس محترم، تصاویر زیان‌دیده را بارگذاری نمایید.
        </Typography>
      </Box>
      <Flex
        gap="1rem"
        maxWidth="maxContainer"
        margin="auto"
        mt="1.5rem"
        className={grid({ columns: 2 })}
      >
        {images.map((image, index) => {
          return (
            <ImageCard
              key={image.url}
              imageData={{
                name: ImagesListName({
                  titleType: 'attachment',
                  index,
                }),
                src: image.url,
              }}
              extension={{
                type: 'moreItems',
                items: ['deletePhoto', 'downloadPhoto', 'editPhoto'],
                handleClick: {
                  onEditSuccess: ({ data, closeModal }) => {
                    editImage({ image: { ...data, id: image.id } });
                    closeModal();
                  },
                  deletePhotoOnClick: ({ closeModal: closeDeleteModal }) => {
                    updateImages({ imageId: image.id });
                    closeDeleteModal();
                  },
                },
              }}
            />
          );
        })}
      </Flex>
    </MainLayout>
  );
};

export default OtherDamagedPreviewImages;
